import { Link } from 'react-router-dom'

interface LogoProps {
  to?: string
  className?: string
  height?: number
}

export default function Logo({ to = '/', className = '', height = 40 }: LogoProps) {
  const img = (
    <img
      src="/logo.png"
      alt="Linkzon"
      style={{ height }}
      className={className}
    />
  )

  if (to) {
    return (
      <Link to={to} className="flex items-center">
        {img}
      </Link>
    )
  }

  return img
}
